/* Parampara — storefront behaviour. No dependencies. */
(function () {
  'use strict';

  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };
  var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';

  /* ---------- money ---------- */
  var moneyFormat = (document.documentElement.getAttribute('data-money-format') || '₹{{amount_no_decimals}}');
  function formatMoney(cents) {
    cents = Math.round(Number(cents) || 0);
    var value;
    var match = moneyFormat.match(/\{\{\s*(\w+)\s*\}\}/);
    var kind = match ? match[1] : 'amount';
    function delimit(n, decimals, thou, dec) {
      var parts = (n / 100).toFixed(decimals).split('.');
      var whole = parts[0];
      // Indian grouping for INR-style formats (12,34,567); western otherwise.
      if (thou === ',' && /₹|Rs/.test(moneyFormat)) {
        var last3 = whole.slice(-3), rest = whole.slice(0, -3);
        whole = rest ? rest.replace(/\B(?=(\d{2})+(?!\d))/g, ',') + ',' + last3 : last3;
      } else {
        whole = whole.replace(/\B(?=(\d{3})+(?!\d))/g, thou);
      }
      return parts[1] ? whole + dec + parts[1] : whole;
    }
    switch (kind) {
      case 'amount_no_decimals': value = delimit(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': value = delimit(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = delimit(cents, 0, '.', ','); break;
      default: value = delimit(cents, cents % 100 === 0 ? 0 : 2, ',', '.');
    }
    return moneyFormat.replace(/\{\{\s*\w+\s*\}\}/, value);
  }
  window.ppFormatMoney = formatMoney;

  /* ---------- offer price ---------- */
  function offerPrice(price, host) {
    if (!host) return price;
    var type = host.getAttribute('data-pp-offer-type') || 'percent';
    var val = parseFloat(host.getAttribute('data-pp-offer-value') || '0') || 0;
    if (!val) return price;
    return type === 'fixed' ? Math.max(0, price - val) : Math.floor(price * (100 - val) / 100);
  }

  /* ---------- toast ---------- */
  var toastEl, toastTimer;
  function toast(msg) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'pp-toast';
      toastEl.setAttribute('role', 'status');
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = msg;
    toastEl.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-visible'); }, 2600);
  }

  /* ---------- overlays (drawer, mobile nav, modal) ---------- */
  var lastFocus = null;
  function openOverlay(el) {
    if (!el) return;
    lastFocus = document.activeElement;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    document.body.classList.add('pp-lock');
    var f = el.querySelector('[data-pp-autofocus], button, a[href], input');
    if (f) setTimeout(function () { f.focus(); }, 60);
  }
  function closeOverlay(el) {
    if (!el) return;
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    if (!$('.pp-drawer.is-open, .pp-mnav.is-open, .pp-modal.is-open')) document.body.classList.remove('pp-lock');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    $$('.pp-drawer.is-open, .pp-mnav.is-open, .pp-modal.is-open').forEach(function (el) {
      if (el.classList.contains('pp-modal')) closeModal(); else closeOverlay(el);
    });
  });

  /* ---------- cart API ---------- */
  function cartFetch(url, body) {
    return fetch(root + url, {
      method: body ? 'POST' : 'GET',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: body ? JSON.stringify(body) : undefined
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) throw new Error(data.description || data.message || 'Something went wrong');
        return data;
      });
    });
  }
  function addItems(items) { return cartFetch('cart/add.js', { items: items }); }
  function getCart() { return cartFetch('cart.js'); }
  function changeLine(key, qty) { return cartFetch('cart/change.js', { id: key, quantity: qty }); }

  function updateCounts(cart) {
    $$('[data-pp-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count;
      el.hidden = cart.item_count === 0 && el.hasAttribute('data-pp-hide-empty');
    });
  }

  /* ---------- cart drawer ---------- */
  var drawer = $('[data-pp-drawer]');
  var compareMap = {};
  try { compareMap = JSON.parse(($('[data-pp-compare-map]') || {}).textContent || '{}'); } catch (err) { compareMap = {}; }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  function renderDrawer(cart) {
    if (!drawer) return;
    updateCounts(cart);
    var cfg = drawer.dataset;
    var body = $('[data-pp-drawer-body]', drawer);
    var foot = $('[data-pp-drawer-foot]', drawer);
    var ship = $('[data-pp-drawer-ship]', drawer);
    $$('[data-pp-drawer-count]', drawer).forEach(function (el) { el.textContent = cart.item_count; });

    if (!cart.item_count) {
      body.innerHTML = '<div class="pp-drawer__empty"><h3>' + esc(cfg.emptyTitle) + '</h3><p class="pp-muted">' + esc(cfg.emptyText) + '</p><a class="pp-btn pp-btn--primary" href="' + esc(cfg.emptyUrl) + '">' + esc(cfg.emptyCta) + '</a></div>';
      foot.hidden = true;
      if (ship) ship.hidden = true;
      return;
    }
    foot.hidden = false;

    // free shipping bar
    var threshold = parseInt(cfg.freeShip || '0', 10);
    if (ship) {
      ship.hidden = !threshold;
      if (threshold) {
        var left = Math.max(0, threshold - cart.total_price);
        var pct = Math.min(100, Math.round(cart.total_price / threshold * 100));
        ship.innerHTML = '<div class="pp-ship__row"><span>' + (left === 0
          ? '<strong>' + esc(cfg.shipDone) + '</strong>'
          : esc(cfg.shipLeft).replace('[amount]', '<strong>' + formatMoney(left) + '</strong>')) +
          '</span><span>' + (left === 0 ? '✓' : '') + '</span></div><div class="pp-ship__track"><i style="width:' + pct + '%"></i></div>';
      }
    }

    var mrp = 0;
    var html = cart.items.map(function (item) {
      var unitCompare = compareMap[item.variant_id] || 0;
      var lineCompare = unitCompare > item.final_price ? unitCompare * item.quantity : item.original_line_price;
      mrp += lineCompare;
      var img = item.image || '';
      var sub = [];
      if (item.variant_title && !/default title/i.test(item.variant_title)) sub.push(item.variant_title);
      if (cfg.batch) sub.push(cfg.batch);
      return '<div class="pp-line" data-key="' + esc(item.key) + '">' +
        '<a class="pp-line__img" href="' + esc(item.url) + '">' + (img ? '<img src="' + esc(img) + (img.indexOf('?') > -1 ? '&' : '?') + 'width=180" alt="" loading="lazy" width="84" height="84">' : '') + '</a>' +
        '<div class="pp-line__info"><a class="pp-line__title" href="' + esc(item.url) + '">' + esc(item.product_title) + '</a>' +
        '<div class="pp-line__sub">' + esc(sub.join(' · ')) + '</div>' +
        (item.discounts && item.discounts.length ? item.discounts.map(function (dd) { return '<span class="pp-line__offer">✦ ' + esc(dd.title) + ' −' + formatMoney(dd.amount) + '</span>'; }).join('') + '<br>' : '') +
        '<div class="pp-qty pp-qty--sm"><button type="button" data-pp-line-qty="-1" aria-label="Decrease">−</button><input type="number" min="0" value="' + item.quantity + '" aria-label="Quantity" data-pp-line-input><button type="button" data-pp-line-qty="1" aria-label="Increase">+</button></div></div>' +
        '<div class="pp-line__price"><strong>' + formatMoney(item.final_line_price) + '</strong>' +
        (lineCompare > item.final_line_price ? '<br><s>' + formatMoney(lineCompare) + '</s>' : '') +
        '<br><button type="button" class="pp-line__remove" data-pp-line-remove>' + esc(cfg.remove) + '</button></div></div>';
    }).join('');

    // size upsell: swap smaller pack for the bigger one
    var fromId = parseInt(cfg.upsellFrom || '0', 10), toId = parseInt(cfg.upsellTo || '0', 10);
    var fromLine = fromId && cart.items.filter(function (i) { return i.variant_id === fromId; })[0];
    if (fromLine && toId) {
      html += '<div class="pp-card pp-upsell"><div><strong>' + esc(cfg.upsellTitle) + '</strong><br><span>' + esc(cfg.upsellText) + '</span></div>' +
        '<button type="button" class="pp-btn pp-btn--secondary" data-pp-swap data-from="' + esc(fromLine.key) + '" data-qty="' + fromLine.quantity + '" data-to="' + toId + '">' + esc(cfg.upsellCta) + '</button></div>';
    }
    body.innerHTML = html;

    var save = Math.max(0, mrp - cart.total_price);
    var offerAmt = 0, offerTitles = [];
    cart.items.forEach(function (it) { (it.discounts || []).forEach(function (dd) { offerAmt += dd.amount; if (offerTitles.indexOf(dd.title) < 0) offerTitles.push(dd.title); }); });
    (cart.cart_level_discount_applications || []).forEach(function (da) { offerAmt += da.total_allocated_amount; if (offerTitles.indexOf(da.title) < 0) offerTitles.push(da.title); });
    var offerRow = $('[data-pp-sum-offer-row]', foot);
    if (offerRow) {
      offerRow.hidden = offerAmt <= 0;
      $('[data-pp-sum-offer-label]', foot).textContent = offerTitles.join(' + ') + ' (offer)';
      $('[data-pp-sum-offer]', foot).textContent = '− ' + formatMoney(offerAmt);
    }
    $('[data-pp-sum-mrp]', foot).textContent = formatMoney(mrp);
    var saveRow = $('[data-pp-sum-save-row]', foot);
    saveRow.hidden = save <= 0;
    $('[data-pp-sum-save]', foot).textContent = '− ' + formatMoney(save);
    $('[data-pp-sum-total]', foot).textContent = formatMoney(cart.total_price);
    var shipEl = $('[data-pp-sum-ship]', foot);
    if (shipEl) shipEl.textContent = threshold && cart.total_price >= threshold ? cfg.shipFree : cfg.shipCalc;
  }

  function refreshCart(open) {
    return getCart().then(function (cart) {
      renderDrawer(cart);
      if (open) openOverlay(drawer);
      return cart;
    });
  }
  window.ppRefreshCart = refreshCart;

  if (drawer) {
    drawer.addEventListener('click', function (e) {
      var t = e.target;
      if (t.closest('[data-pp-drawer-close]')) { closeOverlay(drawer); return; }
      var line = t.closest('.pp-line');
      var qBtn = t.closest('[data-pp-line-qty]');
      if (line && qBtn) {
        var input = $('[data-pp-line-input]', line);
        var q = Math.max(0, parseInt(input.value, 10) + parseInt(qBtn.getAttribute('data-pp-line-qty'), 10));
        line.style.opacity = '.5';
        changeLine(line.getAttribute('data-key'), q).then(renderDrawer).catch(function (err) { toast(err.message); refreshCart(); });
        return;
      }
      if (line && t.closest('[data-pp-line-remove]')) {
        line.style.opacity = '.5';
        changeLine(line.getAttribute('data-key'), 0).then(renderDrawer).catch(function (err) { toast(err.message); });
        return;
      }
      var swap = t.closest('[data-pp-swap]');
      if (swap) {
        swap.classList.add('is-loading');
        changeLine(swap.dataset.from, 0)
          .then(function () { return addItems([{ id: parseInt(swap.dataset.to, 10), quantity: parseInt(swap.dataset.qty, 10) || 1 }]); })
          .then(function () { return refreshCart(); })
          .catch(function (err) { toast(err.message); refreshCart(); });
      }
    });
    drawer.addEventListener('change', function (e) {
      var input = e.target.closest('[data-pp-line-input]');
      if (!input) return;
      var line = input.closest('.pp-line');
      changeLine(line.getAttribute('data-key'), Math.max(0, parseInt(input.value, 10) || 0)).then(renderDrawer).catch(function (err) { toast(err.message); });
    });
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-pp-cart-open]');
    if (opener && drawer) { e.preventDefault(); refreshCart(true); }
  });

  /* ---------- quick add buttons (packs, cards, reels) ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-pp-add]');
    if (!btn) return;
    e.preventDefault();
    var id = parseInt(btn.getAttribute('data-pp-add'), 10);
    if (!id) { if (btn.href) location.href = btn.href; return; }
    btn.classList.add('is-loading');
    addItems([{ id: id, quantity: parseInt(btn.getAttribute('data-pp-qty') || '1', 10) }])
      .then(function () { return refreshCart(!!drawer); })
      .then(function () { if (!drawer) toast(btn.getAttribute('data-pp-added') || 'Added to bag'); })
      .catch(function (err) { toast(err.message); })
      .finally(function () { btn.classList.remove('is-loading'); });
  });

  /* ---------- product page ---------- */
  $$('[data-pp-product]').forEach(function (pdp) {
    var form = $('[data-pp-product-form]', pdp);
    if (!form) return;
    var idInput = $('input[name="id"]', form);
    var qtyInput = $('[data-pp-qty-input]', pdp);
    var addBtns = $$('[data-pp-submit]', pdp);
    var mainImg = $('[data-pp-main-img]', pdp);

    function qty() { return Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1); }

    function setText(sel, val) { $$(sel, pdp).forEach(function (el) { el.textContent = val; }); }

    function selectPack(opt) {
      $$('[data-pp-pack]', pdp).forEach(function (o) { o.classList.toggle('is-active', o === opt); o.setAttribute('aria-checked', o === opt ? 'true' : 'false'); });
      var d = opt.dataset;
      idInput.value = d.variant;
      var base = parseInt(d.price, 10), compare = parseInt(d.compare || '0', 10);
      var price = d.offerOn === 'true' ? offerPrice(base, pdp) : base;
      setText('[data-pp-price]', formatMoney(price));
      setText('[data-pp-compare]', compare > price ? formatMoney(compare) : '');
      $$('[data-pp-compare]', pdp).forEach(function (el) { el.hidden = !(compare > price); });
      $$('[data-pp-off]', pdp).forEach(function (el) {
        el.hidden = !(compare > price);
        if (compare > price) el.textContent = Math.round((compare - price) * 100 / compare) + '% ' + (el.getAttribute('data-suffix') || 'off');
      });
      setText('[data-pp-per]', d.per || '');
      setText('[data-pp-code-price]', formatMoney(offerPrice(base, pdp)));
      var available = d.available !== 'false';
      addBtns.forEach(function (b) { b.disabled = !available; });
      setText('[data-pp-add-label]', available ? (pdp.getAttribute('data-label-add') || 'Add to bag') : (pdp.getAttribute('data-label-soldout') || 'Sold out'));
      if (mainImg && d.image) { mainImg.style.opacity = '0'; setTimeout(function () { mainImg.src = d.image; mainImg.removeAttribute('srcset'); mainImg.style.opacity = '1'; }, 150); }
      if (d.url && window.history && history.replaceState) history.replaceState(null, '', d.url);
    }
    $$('[data-pp-pack]', pdp).forEach(function (opt) {
      opt.addEventListener('click', function (e) { e.preventDefault(); selectPack(opt); });
    });

    // quantity steppers (main + sticky stay in sync)
    $$('[data-pp-qty-step]', pdp).forEach(function (b) {
      b.addEventListener('click', function () {
        var v = Math.max(1, qty() + parseInt(b.getAttribute('data-pp-qty-step'), 10));
        $$('[data-pp-qty-input]', pdp).forEach(function (i) { i.value = v; });
      });
    });
    $$('[data-pp-qty-input]', pdp).forEach(function (i) {
      i.addEventListener('change', function () { var v = qty(); $$('[data-pp-qty-input]', pdp).forEach(function (o) { o.value = Math.max(1, parseInt(i.value, 10) || v); }); });
    });

    function collectItems() {
      var items = [{ id: parseInt(idInput.value, 10), quantity: Math.max(1, parseInt(qtyInput.value, 10) || 1) }];
      var wrap = $('[data-pp-giftwrap]', pdp);
      if (wrap && wrap.checked && wrap.value) items.push({ id: parseInt(wrap.value, 10), quantity: 1 });
      return items;
    }
    function submit(goCheckout, btn) {
      if (btn) btn.classList.add('is-loading');
      return addItems(collectItems())
        .then(function () {
          if (goCheckout) { location.href = root + 'checkout'; return; }
          return refreshCart(!!drawer).then(function () { if (!drawer) toast('Added to bag'); });
        })
        .catch(function (err) { toast(err.message); })
        .finally(function () { if (btn) btn.classList.remove('is-loading'); });
    }
    form.addEventListener('submit', function (e) { e.preventDefault(); submit(false, $('[data-pp-submit]', form)); });
    $$('[data-pp-submit-sticky]', pdp).forEach(function (b) { b.addEventListener('click', function () { submit(false, b); }); });
    $$('[data-pp-buy-now]', pdp).forEach(function (b) { b.addEventListener('click', function () { submit(true, b); }); });

    // gallery thumbs
    $$('[data-pp-thumb]', pdp).forEach(function (t) {
      t.addEventListener('click', function () {
        $$('[data-pp-thumb]', pdp).forEach(function (o) { o.classList.toggle('is-active', o === t); });
        if (mainImg) { mainImg.src = t.getAttribute('data-pp-thumb'); mainImg.removeAttribute('srcset'); }
      });
    });

    // sticky add-to-cart on mobile once the buy box scrolls away
    var sticky = $('[data-pp-sticky-atc]', pdp);
    var buyBox = $('[data-pp-buybox]', pdp);
    if (sticky && buyBox && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        sticky.classList.toggle('is-visible', !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0);
      }).observe(buyBox);
    }
  });

  /* ---------- shop by category tabs + size pills ---------- */
  $$('[data-pp-stabs]').forEach(function (sec) {
    var tabs = $$('[data-pp-stab]', sec), panels = $$('[data-pp-stab-panel]', sec), ind = $('[data-pp-stab-ind]', sec);
    /* gold pill slides under the active tab */
    function moveInd() {
      var on = tabs.filter(function (o) { return o.classList.contains('is-on'); })[0];
      if (!ind || !on) return;
      ind.style.width = on.offsetWidth + 'px';
      ind.style.transform = 'translateX(' + on.offsetLeft + 'px)';
    }
    /* cards flip in one after another: number them, and replay on each tab */
    panels.forEach(function (p) {
      $$('.pp-scard, .pp-stabs__empty', p).forEach(function (c, n) { c.style.setProperty('--n', n); c.setAttribute('data-pp-card3d', ''); });
      if (!p.hidden) p.classList.add('is-anim');
    });
    tabs.forEach(function (t) {
      t.addEventListener('click', function () {
        var i = t.getAttribute('data-pp-stab');
        tabs.forEach(function (o) { var on = o === t; o.classList.toggle('is-on', on); o.setAttribute('aria-selected', on ? 'true' : 'false'); });
        panels.forEach(function (p) {
          p.hidden = p.getAttribute('data-pp-stab-panel') !== i;
          p.classList.remove('is-anim');
          if (!p.hidden) { void p.offsetWidth; p.classList.add('is-anim'); }
        });
        moveInd();
        if (t.scrollIntoView && t.parentNode.scrollWidth > t.parentNode.clientWidth) t.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      });
    });
    moveInd();
    window.addEventListener('resize', moveInd);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(moveInd);
  });

  // size pills on any product card
  document.addEventListener('click', function (e) {
    var pill = e.target.closest('.pp-scard__pill');
    if (!pill || pill.disabled) return;
    var card = pill.closest('[data-pp-scard]'), d = pill.dataset;
    var host = pill.closest('[data-pp-offer-type]');
    $$('.pp-scard__pill', card).forEach(function (o) { var on = o === pill; o.classList.toggle('is-on', on); o.setAttribute('aria-checked', on ? 'true' : 'false'); });
    var price = parseInt(d.price, 10), compare = parseInt(d.compare || '0', 10);
    var shown = card.getAttribute('data-pp-offer-on') === 'true' ? offerPrice(price, host) : price;
    $('[data-pp-scard-price]', card).textContent = formatMoney(shown);
    var c = $('[data-pp-scard-compare]', card); c.hidden = !(compare > shown); if (compare > shown) c.textContent = formatMoney(compare);
    var off = $('[data-pp-scard-off]', card); off.hidden = !(compare > shown); if (compare > shown) off.textContent = Math.round((compare - shown) * 100 / compare) + '% off';
    var best = $('[data-pp-scard-best]', card); if (best) best.textContent = formatMoney(offerPrice(price, host));
    $('[data-pp-add]', card).setAttribute('data-pp-add', d.variant);
    if (d.url) $$('[data-pp-scard-link]', card).forEach(function (a) { a.href = d.url; });
    var img = $('[data-pp-scard-img]', card); if (img && d.image) img.src = d.image;
  });

  /* ---------- inline step videos: play only while on screen ---------- */
  var stepVideos = $$('.pp-step__video video');
  if (stepVideos.length && 'IntersectionObserver' in window) {
    var vio = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var v = en.target;
        if (en.isIntersecting && v.offsetParent !== null) { v.muted = true; var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        else v.pause();
      });
    }, { threshold: 0.25 });
    stepVideos.forEach(function (v) { v.removeAttribute('autoplay'); v.pause(); vio.observe(v); });
  }

  /* ---------- copy coupon ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-pp-copy]');
    if (!b) return;
    var code = b.getAttribute('data-pp-copy');
    var done = function () { var t = b.textContent; b.textContent = 'Copied'; setTimeout(function () { b.textContent = t; }, 1600); };
    if (navigator.clipboard) navigator.clipboard.writeText(code).then(done, done); else done();
  });

  /* ---------- countdowns ---------- */
  function tickCountdowns() {
    $$('[data-pp-countdown]').forEach(function (el) {
      var end = Date.parse(el.getAttribute('data-pp-countdown'));
      if (isNaN(end)) { el.hidden = true; return; }
      var ms = Math.max(0, end - Date.now());
      var d = Math.floor(ms / 864e5), h = Math.floor(ms / 36e5) % 24, m = Math.floor(ms / 6e4) % 60;
      var pad = function (n) { return (n < 10 ? '0' : '') + n; };
      var parts = { d: pad(d), h: pad(h), m: pad(m) };
      $$('[data-unit]', el).forEach(function (u) { u.textContent = parts[u.getAttribute('data-unit')]; });
      if (ms === 0) { var host = el.closest('[data-pp-countdown-host]'); if (host) host.hidden = true; }
    });
  }
  if ($('[data-pp-countdown]')) { tickCountdowns(); setInterval(tickCountdowns, 30000); }

  /* ---------- announcement ticker (phones) ---------- */
  $$('[data-pp-announce]').forEach(function (bar) {
    var items = $$('.pp-announce__item', bar);
    if (items.length < 2) return;
    var i = 0, paused = false, phone = window.matchMedia('(max-width: 640px)');
    bar.addEventListener('mouseenter', function () { paused = true; });
    bar.addEventListener('mouseleave', function () { paused = false; });
    bar.addEventListener('focusin', function () { paused = true; });
    bar.addEventListener('focusout', function () { paused = false; });
    setInterval(function () {
      if (paused || document.hidden || !phone.matches) return;
      var cur = items[i];
      i = (i + 1) % items.length;
      cur.classList.remove('is-active');
      cur.classList.add('is-leaving');
      items[i].classList.add('is-active');
      setTimeout(function () { cur.classList.remove('is-leaving'); }, 550);
    }, 3500);
  });

  /* ---------- trace your jar ---------- */
  $$('[data-pp-trace]').forEach(function (sec) {
    var form = $('[data-pp-trace-form]', sec);
    var data = {};
    try { data = JSON.parse($('[data-pp-trace-data]', sec).textContent); } catch (err) { data = {}; }
    var miss = $('[data-pp-trace-miss]', sec);
    function show(code) {
      var key = String(code || '').trim().toUpperCase().replace(/\s+/g, '');
      var hit = data[key] || data['PF-' + key.replace(/^PF-?/, '')];
      if (!hit) { if (miss) miss.textContent = sec.getAttribute('data-miss').replace('[batch]', code); return; }
      if (miss) miss.textContent = '';
      Object.keys(hit).forEach(function (k) {
        $$('[data-pp-trace-field="' + k + '"]', sec).forEach(function (el) {
          if (k === 'report') { el.hidden = !hit[k]; el.href = hit[k] || '#'; }
          else if (k === 'image') { if (hit[k]) { el.src = hit[k]; el.removeAttribute('srcset'); } }
          else el.textContent = hit[k];
        });
      });
    }
    if (form) form.addEventListener('submit', function (e) { e.preventDefault(); show($('input', form).value); });
    var q = new URLSearchParams(location.search).get('batch');
    if (q) { var inp = form && $('input', form); if (inp) inp.value = q; show(q); }
  });

  /* ---------- reels modal ---------- */
  var modal;
  function closeModal() {
    if (!modal) return;
    var inner = $('.pp-modal__media', modal);
    inner.innerHTML = '';
    closeOverlay(modal);
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-pp-reel]');
    if (!b) return;
    var src = b.getAttribute('data-pp-reel');
    if (!src) return;
    modal = modal || $('[data-pp-modal]');
    if (!modal) return;
    var media = $('.pp-modal__media', modal);
    if (/youtube|youtu\.be|vimeo/.test(src)) {
      media.innerHTML = '<iframe src="' + esc(src) + '" allow="autoplay; encrypted-media; picture-in-picture" allowfullscreen title="Video"></iframe>';
    } else {
      media.innerHTML = '<video src="' + esc(src) + '" autoplay controls playsinline></video>';
    }
    openOverlay(modal);
  });
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-pp-modal-close]') || (e.target.classList && e.target.classList.contains('pp-modal'))) closeModal();
  });

  /* ---------- mobile nav ---------- */
  var mnav = $('[data-pp-mnav]');
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-pp-mnav-open]')) { openOverlay(mnav); return; }
    if (e.target.closest('[data-pp-mnav-close]')) closeOverlay(mnav);
  });

  /* ---------- sticky header shadow ---------- */
  var header = $('[data-pp-header]');
  if (header) {
    var onScroll = function () { header.classList.toggle('is-stuck', window.scrollY > 40); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- notify me ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-pp-notify-open]');
    if (!b) return;
    var wrap = b.closest('.pp-notify');
    wrap.classList.add('is-open');
    var i = $('input[type="email"]', wrap);
    if (i) i.focus();
  });

  /* ---------- collection filter chips ---------- */
  $$('[data-pp-filter-group]').forEach(function (bar) {
    var scope = bar.closest('[data-pp-collection]') || document;
    $$('[data-pp-filter]', bar).forEach(function (chip) {
      chip.addEventListener('click', function () {
        var f = chip.getAttribute('data-pp-filter');
        $$('[data-pp-filter]', bar).forEach(function (c) { c.classList.toggle('is-active', c === chip); c.setAttribute('aria-pressed', c === chip ? 'true' : 'false'); });
        $$('[data-pp-groups]', scope).forEach(function (card) {
          card.hidden = !(f === 'all' || (' ' + card.getAttribute('data-pp-groups') + ' ').indexOf(' ' + f + ' ') > -1);
        });
        $$('[data-pp-soon-wrap]', scope).forEach(function (w) {
          w.hidden = !(f === 'all' || f === 'soon');
        });
      });
    });
  });
  $$('[data-pp-sort]').forEach(function (sel) {
    sel.addEventListener('change', function () {
      var url = new URL(location.href);
      url.searchParams.set('sort_by', sel.value);
      location.href = url.toString();
    });
  });

  /* ---------- process page scroll-spy ---------- */
  var spyLinks = $$('[data-pp-spy] a');
  if (spyLinks.length && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        spyLinks.forEach(function (a) { a.classList.toggle('is-active', a.getAttribute('href') === '#' + en.target.id); });
      });
    }, { rootMargin: '-40% 0px -55% 0px' });
    spyLinks.forEach(function (a) { var t = document.getElementById(a.getAttribute('href').slice(1)); if (t) io.observe(t); });
  }

  /* ---------- cart page qty (no drawer) ---------- */
  $$('[data-pp-cartpage] [data-pp-line-qty]').forEach(function (b) {
    b.addEventListener('click', function () {
      var input = b.parentNode.querySelector('input');
      input.value = Math.max(0, (parseInt(input.value, 10) || 0) + parseInt(b.getAttribute('data-pp-line-qty'), 10));
      input.form.submit();
    });
  });

  /* ---------- hero 3D tilt: follows the pointer on desktop, the scroll on phones ---------- */
  if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    $$('[data-pp-tilt]').forEach(function (box) {
      var stage = box.querySelector('.pp-hero__stage');
      if (!stage) return;
      var fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
      var tx = 0, ty = 0, cx = 0, cy = 0, gx = 30, gy = 20, raf = 0, t0 = performance.now();
      function frame(now) {
        if (!fine) {
          /* phones: gentle idle sway plus a lean that follows the scroll */
          var r = box.getBoundingClientRect(), mid = (r.top + r.height / 2) / window.innerHeight - .5;
          var t = (now - t0) / 1000;
          tx = Math.sin(t * .8) * 6;
          ty = mid * -14 + Math.cos(t * .6) * 2;
          gx = 50 + tx * 4; gy = 30 - ty * 3;
        }
        cx += (tx - cx) * .08; cy += (ty - cy) * .08;
        stage.style.setProperty('--ry', cx.toFixed(2) + 'deg');
        stage.style.setProperty('--rx', cy.toFixed(2) + 'deg');
        stage.style.setProperty('--gx', gx.toFixed(1) + '%');
        stage.style.setProperty('--gy', gy.toFixed(1) + '%');
        raf = (!fine || Math.abs(tx - cx) > .02 || Math.abs(ty - cy) > .02) ? requestAnimationFrame(frame) : 0;
      }
      function kick() { if (!raf) raf = requestAnimationFrame(frame); }
      if (fine) {
        box.addEventListener('pointermove', function (e) {
          var r = box.getBoundingClientRect(), x = (e.clientX - r.left) / r.width, y = (e.clientY - r.top) / r.height;
          tx = (x - .5) * 18; ty = (.5 - y) * 14; gx = x * 100; gy = y * 100;
          kick();
        });
        box.addEventListener('pointerleave', function () { tx = 0; ty = 0; gx = 30; gy = 20; kick(); });
      } else {
        /* only animate while the hero is on screen */
        new IntersectionObserver(function (en) {
          if (en[0].isIntersecting) kick(); else { cancelAnimationFrame(raf); raf = 0; }
        }).observe(box);
      }
    });
  }

  /* ---------- count a stat up from 0, keeping its text around the number ("10,000+", "4.9/5") ---------- */
  function countUp(el) {
    var txt = el.textContent, m = txt.match(/[\d,.]+/);
    if (!m) return;
    var raw = m[0], target = parseFloat(raw.replace(/,/g, '')), dec = (raw.split('.')[1] || '').length, comma = raw.indexOf(',') > -1;
    if (!isFinite(target)) return;
    var t0 = performance.now(), dur = 1600;
    (function tick(now) {
      var k = Math.min(1, (now - t0) / dur), v = target * (1 - Math.pow(1 - k, 3));
      var str = dec ? v.toFixed(dec) : String(Math.round(v));
      if (comma) str = Number(str).toLocaleString('en-IN', { minimumFractionDigits: dec, maximumFractionDigits: dec });
      el.textContent = txt.replace(raw, str);
      if (k < 1) requestAnimationFrame(tick); else el.textContent = txt;
    })(t0);
  }

  /* ---------- reveal on scroll: [data-pp-reveal] gets .is-in once it is on screen ---------- */
  if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    var rio = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        en.target.classList.add('is-in');
        rio.unobserve(en.target);
        $$('[data-pp-count]', en.target).forEach(countUp);
        /* once the flip-in is over, let hover tilt react quickly */
        setTimeout(function () { $$('[data-pp-card3d]', en.target).forEach(function (c) { c.classList.add('is-settled'); }); }, 1600);
      });
    }, { threshold: .08, rootMargin: '0px 0px -8% 0px' });
    $$('[data-pp-reveal]').forEach(function (el) {
      /* .pp-rv items rise in one after another unless they already carry their own --n */
      $$('.pp-rv', el).forEach(function (r, n) { if (!r.style.getPropertyValue('--n')) r.style.setProperty('--n', n); });
      el.classList.add('pp-reveal-ready');
      rio.observe(el);
    });
  }

  /* ---------- 3D card tilt on hover (desktop pointers only) ---------- */
  if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
    $$('[data-pp-card3d]').forEach(function (c) {
      c.addEventListener('pointermove', function (e) {
        var r = c.getBoundingClientRect();
        c.style.setProperty('--ry', (((e.clientX - r.left) / r.width - .5) * 16).toFixed(1) + 'deg');
        c.style.setProperty('--rx', ((.5 - (e.clientY - r.top) / r.height) * 12).toFixed(1) + 'deg');
      });
      c.addEventListener('pointerleave', function () { c.style.setProperty('--rx', '0deg'); c.style.setProperty('--ry', '0deg'); });
    });
  }

  /* ---------- pantry shelf: progress bar under the phone carousel ---------- */
  $$('[data-pp-pan]').forEach(function (shelf) {
    var bar = shelf.parentNode.querySelector('[data-pp-pan-bar]');
    if (!bar) return;
    function sync() {
      var max = shelf.scrollWidth - shelf.clientWidth, seen = shelf.clientWidth / shelf.scrollWidth;
      bar.style.width = Math.min(100, (seen + (max > 0 ? shelf.scrollLeft / max : 1) * (1 - seen)) * 100) + '%';
    }
    shelf.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    sync();
  });

  /* ---------- footer: back to top ---------- */
  $$('[data-pp-top]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      e.preventDefault();
      window.scrollTo({ top: 0, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    });
  });

  /* ---------- theme editor: keep drawer usable when sections reload ---------- */
  document.addEventListener('shopify:section:load', function () { tickCountdowns(); });
})();
